import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignLeftSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15 17H3v2h12v-2zm0-8H3v2h12V9zM3 15h18v-2H3v2zM3 5v2h18V5H3z" />
  </svg>
);
export default IconAlignLeftSizeM;
